import { useEffect, useState } from 'react';
import { getMe } from '../services/me/getMe';
export const useMe = props => {
  const [meIsLoading, setMeIsLoading] = useState(true);
  const [meData, setMeData] = useState({});
  useEffect(() => {
    if (props === null || props === void 0 ? void 0 : props.cancelFetch) {
      setMeIsLoading(false);
      return;
    }
    const abortController = new AbortController();
    setMeIsLoading(true);
    getMe(props === null || props === void 0 ? void 0 : props.teamKey, abortController.signal).then(data => setMeData(data)).finally(() => setMeIsLoading(false));
    return () => {
      abortController.abort();
    };
  }, [props === null || props === void 0 ? void 0 : props.cancelFetch, props === null || props === void 0 ? void 0 : props.teamKey]);
  return {
    meIsLoading,
    meData
  };
};